import axios from 'axios'
import './common'

export default {
    getList: (params) => axios.get(`/isolangs`, { params: params }),
    getSpoken: () => axios.get(`/langs`),
}